import AdminAddBranchRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/admin-add-branch-request-dto";
import AdminBranchesViewRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/admin-branches-view-request-dto";
import AdminUpdateBranchRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/admin-update-branch-request-dto";
import { AdvancedSolarEstimationCalculationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/advanced-solar-estimation-calculation-request-dto";
import CalculateSolarEstimationCostRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/calculate-solar-estimation-cost-request-dto";
import ChangeSolarEstimationStatusRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/change-solar-estimation-status-request-dto";
import { CreateSolarEstimationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/create-solar-estimation-request-dto";
import { InitiateSolarEstimationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/initiate-solar-estimation-request-dto";
import ModifySolarEstimationRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/modify-solar-estimation-request-dto";
import { PersistEstimationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/persist-estimation-request-dto";
import { SolarEstimationCreateSpaceClusterRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/solar-estimation-create-space-cluster-request-dto";
import { SolarEstimationUserSelectionRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/solar-estimation-user-selection-request-dto";
import SubmitForApprovalRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/submit-for-approval-request-dto";
import { UpdateSolarEstimationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/update-estimation-request-dot";
import ViewPurchaseHistoriesRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-purchase-histories-request-dto";
import { ViewSolarEstimationRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/view-solar-estimation-request-dto";
import { ViewSolarEstimationsRequestDTO } from "../../../shared/oversight-core/dtos/request-dtos/view-solar-estimations-request-dto";
import AdminBranchViewResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/admin-branch-view-response-dto";
import AdminBranchesViewResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/admin-branches-view-response-dto";
import AdminViewBranchListResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/admin-view-branch-list-response-dto";
import { AdvancedSolarEstimationCalculationResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/advanced-solar-estimation-calculation-response-dto";
import CalculateSolarEstimationCostResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/calculate-solar-estimation-cost-response-dto";
import ChangeSolarEstimationStatusResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/change-solar-estimation-status-response-dto";
import DuplicateEstimationResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/duplicate-estimation-response-dto";
import ModifySolarEstimationResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/modify-solar-estimation-response-dto";
import { PersistEstimationResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/persist-estimation-response-dto";
import PublicTariffResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/public-tariff-response-dto";
import { SolarEstimationUserSelectionResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/solar-estimation-user-selection-response-dto";
import ViewPurchaseHistoriesResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-purchase-histories-response-dto";
import { ViewSolarEstimationResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-solar-estimation-response-dto";
import { IViewSolarEstimationSummaryResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-solar-estimation-summary-response-dto";
import ViewSolarEstimationTimelineResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-solar-estimation-timeline-response-dto";
import { ViewSolarEstimationUpdateHistoryResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-solar-estimation-update-history-response-dto";
import { ViewSolarEstimationsResponseDTO } from "../../../shared/oversight-core/dtos/response-dtos/view-solar-estimations-response-dto";
import { EstimationExportFileFormat } from "../../../shared/oversight-core/enums/estimation-export-file-format";
import { ISolarEstimationIdAndToken } from "../../../shared/oversight-core/interfaces/solar-estimation-id-and-token";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const solarEstimationAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    initiateSolarEstimation: builder.mutation<
      ISolarEstimationIdAndToken,
      InitiateSolarEstimationRequestDTO
    >({
      query(data) {
        return {
          url: "estimation/initiate",
          method: "POST",
          body: data,
        };
      },
      transformErrorResponse,
    }),
    persistEstimation: builder.mutation<
      PersistEstimationResponseDTO,
      PersistEstimationRequestDTO
    >({
      query(data) {
        return {
          url: "estimation/basic-schedule/persist",
          method: "POST",
          params: {
            estimationId: data.estimationId,
            estimationToken: data.estimationToken,
          },
          body: {
            title: data.title,
            usages: data.usages,
            isDraft: data.isDraft,
            countryCode: data.countryCode,
          },
        };
      },
      transformErrorResponse,
    }),
    updateEstimation: builder.mutation<
      ISolarEstimationIdAndToken,
      UpdateSolarEstimationRequestDTO
    >({
      query(data) {
        return {
          url: "estimation/update",
          method: "POST",
          params: {
            estimationId: data.estimationId,
            estimatorToken: data.estimatorToken,
          },
          body: {
            title: data.title,
            estimationType: data.estimationType,
            applicationType: data.applicationType,
            utilityOptionType: data.utilityOptionType,
            solarEstimationType: data.solarEstimationType,
            systemType: data.systemType,
            inverterPhaseType: data.inverterPhaseType,
            monthlyRequiredEnergy: data.monthlyRequiredEnergy,
            maxRequiredPower: data.maxRequiredPower,
            numberOfUsers: data.numberOfUsers,
            nightLoad: data.nightLoad,
            sunlightHours: data.sunlightHours,
            estimationSpaceClusterId: data.estimationSpaceClusterId,
            estimationBasicScheduleId: data.estimationBasicScheduleId,
            isDraft: data.isDraft,
            countryCode: data.countryCode,
            installationCostRequested: data.installationCostRequested,
            systemVoltage: data.systemVoltage,
            autonomyDays: data.autonomyDays,
            demandPerUser: data.demandPerUser,
          },
        };
      },
      transformErrorResponse,
    }),
    advancedSolarEstimationCalculation: builder.query<
      AdvancedSolarEstimationCalculationResponseDTO,
      AdvancedSolarEstimationCalculationRequestDTO
    >({
      query: (data) => ({
        url: "estimation/advanced/calculation",
        method: "GET",
        params: {
          spaceClusterId: data.spaceClusterId,
          subRootSpaceId: data.subRootSpaceId,
          scheduledYear: data.scheduledYear,
          scheduledMonth: data.scheduledMonth,
          zoneOffSet: data.zoneOffSet,
        },
      }),
      transformErrorResponse,
    }),
    publicListTariffs: builder.query<PublicTariffResponseDTO, void>({
      query() {
        return {
          url: `estimation/tariff/list`,
          method: "GET",
        };
      },
      transformErrorResponse,
    }),
    createSolarEstimation: builder.mutation<
      ISolarEstimationIdAndToken,
      CreateSolarEstimationRequestDTO
    >({
      query: (data) => ({
        url: "estimation/create",
        method: "POST",
        params: {
          estimationId: data.estimationId,
          estimatorToken: data.estimatorToken,
        },
        body: {
          title: data.title,
          estimationType: data.estimationType,
          applicationType: data.applicationType,
          utilityOptionType: data.utilityOptionType,
          solarEstimationType: data.solarEstimationType,
          systemType: data.systemType,
          inverterPhaseType: data.inverterPhaseType,
          monthlyRequiredEnergy: data.monthlyRequiredEnergy,
          maxRequiredPower: data.maxRequiredPower,
          numberOfUsers: data.numberOfUsers,
          nightLoad: data.nightLoad,
          sunlightHours: data.sunlightHours,
          systemVoltage: data.systemVoltage,
          autonomyDays: data.autonomyDays,
          demandPerUser: data.demandPerUser,
          estimationSpaceClusterId: data.estimationSpaceClusterId,
          estimationBasicScheduleId: data.estimationBasicScheduleId,
          isDraft: data.isDraft,
          countryCode: data.countryCode,
          brandPriority: data.brandPriority,
          brandPriorityPreference: data.brandPriorityPreference,
          optimizeForCost: data.optimizeForCost,
          preferHighEfficiencyPanels: data.preferHighEfficiencyPanels,
          recommendExpandableSystems: data.recommendExpandableSystems,
          hasChanged: data.hasChanged,
          controllerRequired: data.controllerRequired,
        },
      }),
      transformErrorResponse,
    }),
    viewSolarEstimation: builder.query<
      ViewSolarEstimationResponseDTO,
      ViewSolarEstimationRequestDTO
    >({
      query: (data) => ({
        url: `estimation/view`,
        method: "GET",
        params: {
          estimatorToken: data.estimatorToken,
          estimationId: data.estimationId,
        },
      }),
      transformErrorResponse,
    }),
    createSpaceCluster: builder.mutation<
      {
        id: string;
        spaceClusterId: string;
        rootSpaceId: string;
        token: string;
      },
      SolarEstimationCreateSpaceClusterRequestDTO
    >({
      query: (data) => ({
        url: `estimation/${data.estimationId}/space-cluster/create`,
        method: "POST",
        body: {
          spaceClusterLabel: data.spaceClusterLabel,
          rootSpaceName: data.rootSpaceName,
        },
      }),
    }),
    userSelection: builder.mutation<
      SolarEstimationUserSelectionResponseDTO,
      SolarEstimationUserSelectionRequestDTO
    >({
      query: (data) => ({
        url: `estimation/user-selection/update`,
        method: "POST",
        params: {
          estimationId: data.estimationId,
          estimatorToken: data.estimatorToken,
        },
        body: {
          userSelections: data.userSelections,
        },
      }),
    }),
    adminSelection: builder.mutation<
      ModifySolarEstimationResponseDTO,
      ModifySolarEstimationRequestDTO
    >({
      query: (data) => ({
        url: `admin/estimation/user-selection/modify`,
        method: "POST",
        params: {
          estimationId: data.estimationId,
        },
        body: {
          userSelections: data.userSelections,
        },
      }),
    }),
    viewSolarEstimations: builder.query<
      ViewSolarEstimationsResponseDTO,
      ViewSolarEstimationsRequestDTO
    >({
      query: (data) => ({
        url: `estimation/list`,
        method: "GET",
        params: {
          ...data,
        },
      }),
      transformErrorResponse,
    }),
    viewSolarEstimationsAdmin: builder.query<
      ViewSolarEstimationsResponseDTO,
      ViewSolarEstimationsRequestDTO
    >({
      query: (data) => ({
        url: `admin/estimation/list`,
        method: "GET",
        params: {
          ...data,
        },
      }),
      transformErrorResponse,
    }),
    viewSolarEstimationUpdateHistory: builder.query<
      ViewSolarEstimationUpdateHistoryResponseDTO,
      { estimationId?: string; estimatorToken?: string }
    >({
      query: ({ estimationId, estimatorToken }) => ({
        url: `estimation/update-history/view`,
        method: "GET",
        params: {
          estimationId,
          estimatorToken,
        },
      }),
      transformErrorResponse,
    }),
    submitForApproval: builder.mutation<
      ISolarEstimationIdAndToken,
      SubmitForApprovalRequestDTO
    >({
      query: ({
        estimationId,
        estimatorToken,
        includeInstallationCost,
        address,
        longitude,
        latitude,
        note,
      }) => ({
        url: `estimation/expert-approval/submit`,
        method: "POST",
        params: {
          estimationId,
          estimatorToken,
        },
        body: {
          includeInstallationCost,
          address,
          longitude,
          latitude,
          note,
        },
      }),
      transformErrorResponse,
    }),
    deleteSolarEstimation: builder.mutation<void, { estimationId: string }>({
      query({ estimationId }) {
        return {
          url: `estimation/${estimationId}/delete`,
          method: "DELETE",
        };
      },
      transformErrorResponse,
    }),
    viewSolarEstimationAdmin: builder.query<
      ViewSolarEstimationResponseDTO,
      { estimationId: string }
    >({
      query: ({ estimationId }) => ({
        url: `admin/estimation/${estimationId}/view`,
        method: "GET",
      }),
      transformErrorResponse,
    }),
    changeSolarEstimationStatus: builder.mutation<
      ChangeSolarEstimationStatusResponseDTO,
      ChangeSolarEstimationStatusRequestDTO
    >({
      query(data) {
        return {
          url: `admin/estimation/${data.estimationId}/change-status`,
          method: "POST",
          body: {
            status: data.status,
            adminComment: data.adminComment,
            branchIdentity: data.branchIdentity,
            accessoryCost: data.accessoryCost,
          },
        };
      },
      transformErrorResponse,
    }),
    addBranchAdmin: builder.mutation<{ id: string }, AdminAddBranchRequestDTO>({
      query(data) {
        return {
          url: `admin/branch/add`,
          method: "POST",
          body: data,
        };
      },
      transformErrorResponse,
    }),
    updateBranch: builder.mutation<{ id: string }, AdminUpdateBranchRequestDTO>(
      {
        query(data) {
          return {
            url: `admin/branch/${data.branchId}/update`,
            method: "PUT",
            body: data,
          };
        },
        transformErrorResponse,
      },
    ),
    deleteBranchAdmin: builder.mutation<void, { branchId: string }>({
      query({ branchId }) {
        return {
          url: `admin/branch/${branchId}/delete`,
          method: "DELETE",
        };
      },
      transformErrorResponse,
    }),
    viewBranchesAdmin: builder.query<
      AdminBranchesViewResponseDTO,
      AdminBranchesViewRequestDTO
    >({
      query: (data) => ({
        url: `admin/branch/search`,
        method: "GET",
        params: {
          ...data,
        },
      }),
      transformErrorResponse,
    }),
    viewBranchListAdmin: builder.query<AdminViewBranchListResponseDTO, void>({
      query: () => ({
        url: `admin/branch/list`,
        method: "GET",
      }),
      transformErrorResponse,
    }),
    viewBranchAdmin: builder.query<
      AdminBranchViewResponseDTO,
      { branchId: string }
    >({
      query: ({ branchId }) => ({
        url: `admin/branch/${branchId}/view`,
        method: "GET",
      }),
      transformErrorResponse,
    }),
    calculateSolarEstimationCostAdmin: builder.mutation<
      CalculateSolarEstimationCostResponseDTO,
      CalculateSolarEstimationCostRequestDTO
    >({
      query(data) {
        return {
          url: `admin/estimation/${data.estimationId}/calculate`,
          method: "POST",
          body: {
            branchIdentity: data.branchIdentity,
            address: data.address,
            longitude: data.longitude,
            latitude: data.latitude,
          },
        };
      },
      transformErrorResponse,
    }),
    calculateSolarEstimationCost: builder.mutation<
      CalculateSolarEstimationCostResponseDTO,
      CalculateSolarEstimationCostRequestDTO
    >({
      query(data) {
        return {
          url: `estimation/calculate`,
          method: "POST",
          params: {
            estimationId: data.estimationId,
            estimatorToken: data.estimatorToken,
          },
          body: {
            address: data.address,
            longitude: data.longitude,
            latitude: data.latitude,
            installationCostRequired: data.installationCostRequired,
          },
        };
      },
      transformErrorResponse,
    }),
    viewSolarEstimationTimeline: builder.query<
      ViewSolarEstimationTimelineResponseDTO,
      { estimationId?: string; estimatorToken?: string }
    >({
      query: ({ estimationId, estimatorToken }) => ({
        url: `estimation/timeline/view`,
        method: "GET",
        params: {
          estimationId,
          estimatorToken,
        },
      }),
      transformErrorResponse,
    }),
    downloadSolarEstimationSummary: builder.query<
      Blob,
      { estimationId: string; format?: EstimationExportFileFormat }
    >({
      query: ({ estimationId, format }) => ({
        url: `estimation/${estimationId}/download`,
        method: "GET",
        params: {
          format,
        },
        responseHandler: (response) => response.blob(),
      }),
      transformErrorResponse,
    }),
    viewSolarEstimationSummary: builder.query<
      IViewSolarEstimationSummaryResponseDTO,
      void
    >({
      query: () => ({
        url: `admin/estimation/summary`,
        method: "GET",
      }),
      transformErrorResponse,
    }),
    purchaseSolarEstimation: builder.mutation<
      { id: string },
      { estimationId: string }
    >({
      query({ estimationId }) {
        return {
          url: `estimation/${estimationId}/purchase`,
          method: "POST",
        };
      },
      transformErrorResponse,
    }),
    viewPurchaseHistoriesAdmin: builder.query<
      ViewPurchaseHistoriesResponseDTO,
      ViewPurchaseHistoriesRequestDTO
    >({
      query: (data) => ({
        url: `admin/purchase-history/view`,
        method: "GET",
        params: { ...data },
      }),
      transformErrorResponse,
    }),
    viewPurchaseHistories: builder.query<
      ViewPurchaseHistoriesResponseDTO,
      ViewPurchaseHistoriesRequestDTO
    >({
      query: (data) => ({
        url: `purchase-history/view`,
        method: "GET",
        params: { ...data },
      }),
      transformErrorResponse,
    }),
    downloadSolarEstimationTimeline: builder.query<
      Blob,
      { estimationId: string; format?: EstimationExportFileFormat }
    >({
      query: ({ estimationId, format }) => ({
        url: `estimation/${estimationId}/timeline/download`,
        method: "GET",
        params: {
          format,
        },
        responseHandler: (response) => response.blob(),
      }),
      transformErrorResponse,
    }),
    duplicateEstimation: builder.query<
      DuplicateEstimationResponseDTO,
      { estimationId: string }
    >({
      query: ({ estimationId }) => ({
        url: `estimation/${estimationId}/duplicate`,
        method: "GET",
      }),
      transformErrorResponse,
    }),
  }),
  overrideExisting: false,
});

export const {
  useInitiateSolarEstimationMutation,
  usePersistEstimationMutation,
  useUpdateEstimationMutation,
  useLazyAdvancedSolarEstimationCalculationQuery,
  useLazyPublicListTariffsQuery,
  useCreateSolarEstimationMutation,
  useLazyViewSolarEstimationQuery,
  useCreateSpaceClusterMutation,
  useUserSelectionMutation,
  useAdminSelectionMutation,
  useLazyViewSolarEstimationsQuery,
  useLazyViewSolarEstimationsAdminQuery,
  useLazyViewSolarEstimationUpdateHistoryQuery,
  useSubmitForApprovalMutation,
  useDeleteSolarEstimationMutation,
  useLazyViewSolarEstimationAdminQuery,
  useChangeSolarEstimationStatusMutation,
  useAddBranchAdminMutation,
  useUpdateBranchMutation,
  useDeleteBranchAdminMutation,
  useLazyViewBranchesAdminQuery,
  useLazyViewBranchListAdminQuery,
  useLazyViewBranchAdminQuery,
  useCalculateSolarEstimationCostAdminMutation,
  useCalculateSolarEstimationCostMutation,
  useLazyViewSolarEstimationTimelineQuery,
  useLazyDownloadSolarEstimationSummaryQuery,
  useLazyViewSolarEstimationSummaryQuery,
  usePurchaseSolarEstimationMutation,
  useLazyViewPurchaseHistoriesAdminQuery,
  useLazyViewPurchaseHistoriesQuery,
  useLazyDownloadSolarEstimationTimelineQuery,
  useLazyDuplicateEstimationQuery,
} = solarEstimationAPI;
